export enum DeclineFormKeys {
    Comment = 'decline-comment',
}
